module.exports = __webpack_public_path__ + "18d6bed7aef8ddf7a9485259621b7515.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-19.png
// module id = 2146
// module chunks = 0